import { FaqNotLoggedInEntriesResp } from 'types/api/response/faq-not-logged-in-entries-resp'

import { api } from './api'

export const getFaqNotLoggedInEntries = () =>
  api.get<FaqNotLoggedInEntriesResp>('/faq_entries/not_logged_in')
